import { useEffect, useRef } from "react";

export function useThrottle<F>(fn: F, delay: number, dep: any[] = []) {
  const { current } = useRef<{ fn: F; timer?: null | NodeJS.Timeout }>({ fn, timer: null });
  useEffect(
    function () {
      current.fn = fn;
    },
    [fn]
  );

  useEffect(() => {
    if (!current.timer) {
      current.timer = setTimeout(() => {
        delete current.timer;
        (fn as Function)();
      }, delay);
    }
  }, [dep]);
}
